/* app/js/src/components/external-mam/external-mam-providers-layout/external-mam-providers-layout.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  height: 80vh;
  width: 960px;
  overflow-y: auto;
  background-color: #ffffff;
  min-width: 45vw;
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.emsp-layout {
  display: flex;
  padding: 25px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.emsp-layout .emsp-frame {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  position: relative;
  align-self: stretch;
  width: 100%;
  flex: 1;
}
.emsp-layout .emsp-frame .text-wrapper {
  position: relative;
  align-self: stretch;
  margin-top: -1px;
  font-family: "Open Sans-SemiBold", Helvetica;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  font-size: 20px;
  letter-spacing: 0;
  line-height: 30px;
}
.emsp-providers {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  position: relative;
}
/*# sourceMappingURL=external-mam-providers-layout.component.css.map */
